<section class="rs-content-wrapper rs-header-has-level2" id="splitBillDetails">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-txt-c2">{{ 'mobile.splitBill.title' | translate }}</h1>

          <div class="rs-panel-big rs-bg-c2 clearfix">
            <p>{{ 'mobile.splitBill.description' | translate }}</p>
            <div class="row">
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey2">
                  <p class="rs-txt-details rs-txt-s3">
                    <i class="icon-Refresh icon-lh rs-margin-right1" aria-hidden="true"></i
                    >{{ lastUpdate }}
                  </p>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <h2 class="rs-tit6 rs-padding-bottom2 rs-txt-c1">
                        {{ 'mobile.splitBill.employee.total' | translate }}
                      </h2>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink" *ngIf="employeeTotalAmount">
                      <p>
                        <px-currency-amount
                          [amount]="employeeTotalAmount"
                          [amountClass]="'rs-price-s rs-price-exceed'"
                        ></px-currency-amount>
                      </p>
                    </div>
                  </div>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <p>{{ 'mobile.splitBill.employee.invoice' | translate }}</p>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <p class="rs-font-pxB">{{ currencyUnit + employeeInvoice }}</p>
                    </div>
                  </div>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <p>{{ 'mobile.splitBill.mobile.payment' | translate }}</p>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <p class="rs-font-pxB">{{ currencyUnit + mobilePayment }}</p>
                    </div>
                  </div>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <h2 class="rs-tit6 rs-padding-bottom2 rs-txt-c1">
                        {{ 'mobile.splitBill.employer.total' | translate }}
                      </h2>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink" *ngIf="employerTotalAmount">
                      <p>
                        <px-currency-amount
                          [amount]="employerTotalAmount"
                          [amountClass]="'rs-price-s'"
                        ></px-currency-amount>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="rs-txt-s3 rs-txt-details">
              {{ 'mobile.splitBill.asterix.note' | translate }}
            </p>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
